import { render, staticRenderFns } from "./LoyaltyCardExchangeDetail.vue?vue&type=template&id=f7137f4e&scoped=true&"
import script from "./LoyaltyCardExchangeDetail.vue?vue&type=script&lang=js&"
export * from "./LoyaltyCardExchangeDetail.vue?vue&type=script&lang=js&"
import style0 from "../../less/gift.less?vue&type=style&index=0&id=f7137f4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7137f4e",
  null
  
)

export default component.exports